import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { Button, TextField } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { SimpleModal, BackdropLoader } from '@livable/saas-react-components';
import { useStore } from 'src/stores';
export const AddProductModal = observer(function AddProductModal(_ref) {
  var _store$stripe$createP, _store$stripe$createP2, _store$stripe$updateP, _store$stripe$updateP2;
  let isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onSave = _ref.onSave,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'add' : _ref$mode,
    product = _ref.product;
  const store = useStore();
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    productName = _useState2[0],
    setProductName = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    submitError = _useState4[0],
    setSubmitError = _useState4[1];
  const isEdit = mode === 'edit';
  const isSubmitting = ((_store$stripe$createP = (_store$stripe$createP2 = store.stripe.createProductAsync) === null || _store$stripe$createP2 === void 0 ? void 0 : _store$stripe$createP2.inProgress) !== null && _store$stripe$createP !== void 0 ? _store$stripe$createP : false) || ((_store$stripe$updateP = (_store$stripe$updateP2 = store.stripe.updateProductAsync) === null || _store$stripe$updateP2 === void 0 ? void 0 : _store$stripe$updateP2.inProgress) !== null && _store$stripe$updateP !== void 0 ? _store$stripe$updateP : false);
  useEffect(() => {
    if (isOpen) {
      setProductName(isEdit && product ? product.name || '' : '');
      setSubmitError(null);
    }
  }, [isOpen, isEdit, product]);
  const handleSubmit = async () => {
    const name = (productName || '').trim();
    if (!name) {
      setSubmitError('Product name is required');
      return;
    }
    setSubmitError(null);
    try {
      if (isEdit && product !== null && product !== void 0 && product.id) {
        await store.stripe.updateProductAsync.run({
          id: product.id,
          name
        });
      } else {
        await store.stripe.createProductAsync.run({
          name
        });
      }
      onSave === null || onSave === void 0 || onSave();
      onClose();
      store.stripe.getPriceDashboardAsync.run();
      store.stripe.getAllProductsAsync.run();
    } catch (err) {
      var _err$message;
      console.error(isEdit ? 'Update product failed:' : 'Create product failed:', err);
      setSubmitError((_err$message = err === null || err === void 0 ? void 0 : err.message) !== null && _err$message !== void 0 ? _err$message : isEdit ? 'Failed to update product' : 'Failed to create product');
    }
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: null,
    isOpen: isOpen,
    handleClose: onClose,
    title: isEdit ? 'Edit product' : 'Add product',
    leftButton: /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      onClick: onClose,
      disabled: isSubmitting
    }, "Cancel"),
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      onClick: handleSubmit,
      disabled: isSubmitting || !(productName || '').trim()
    }, isSubmitting ? 'Saving...' : 'Save product')
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isSubmitting
  }), /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: "Product name",
    value: productName,
    onChange: e => setProductName(e.target.value),
    error: Boolean(submitError),
    helperText: submitError,
    placeholder: "Enter product name",
    autoFocus: true,
    sx: {
      mt: 1
    }
  }));
});